<template>
  <!-- RATE DATE TO COMPARE -->
  <div :id="$options.name">
    <v-row class="mt-n4">
      <!-- <a-card> yearly_calendar: {{ yearly_calendar }} </a-card> -->
      <v-col cols="12" class="pt-0">
        <a-rms-strategy-weeks
          ref="a-rms-strategy-weeks"
          :event_period="event_period"
        ></a-rms-strategy-weeks>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters, mapActions } from "vuex";
import aRmsStrategyWeeks from "@/components/rms/aRmsStrategyWeeks";

export default {
  name: "rms-strategy-app",
  components: {
    aRmsStrategyWeeks
  },
  props: {
    event_period: {
      type: Array,
      default: () => []
    }
  },
  data: vm => ({
    subscribed_modules: [
      "rms_kpis_monthly_graph",
      "rms_kpis_month_graph",
      "rms_kpis_pickup_month_graph1",
      "rms_kpis_pickup_month_graph2",
      "rms_segments_period_graph"
    ],
    init_date: null
  }),
  watch: {
    current_hotel() {
      if (!this.extraction_id) {
        this.setDefault();
      }
    }
  },
  methods: {
    setDefault() {
      // Must set init_date as today using moment.js
      this.init_date = Vue.moment().format("YYYY-MM-DD");
    },
    ...mapActions([])
  },
  mounted() {},
  computed: {
    ...mapState({}),
    ...mapGetters({
      current_hotel: "current_hotel",
      yearly_calendar: "getYearlyCalendar",
      opened_days: "opened_days"
    })
  }
};
</script>
<style scoped></style>
